// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#rols_code {
    background: url('arrow_down.3e717c92f816c5bb.svg') 99% center no-repeat;
}

.selectwidthauto {
    text-overflow:ellipsis;
    display: inline;
    width: 100%;
}

.mat-mdc-raised-button>.mat-icon{
    width: 36px;
    height: 36px;
    padding: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
